
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"-2 0 17 15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.475 14.002v-1.445a2.883 2.883 0 00-2.878-2.889H3.842a2.883 2.883 0 00-2.877 2.889v1.445M9.597 3.889a2.883 2.883 0 01-2.878 2.889 2.883 2.883 0 01-2.877-2.89A2.883 2.883 0 016.719 1a2.883 2.883 0 012.878 2.889z","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    